<style  scoped>

.section { text-align: center; font: 50px "Microsoft Yahei"; color: #fff;}
.fp-controlArrow { display: none;}
#menu { margin: 0; padding: 0; 
            position: absolute;
            top: calc(50% - 120px);
            left: 20px;  list-style-type: none; z-index: 70; min-width: 150px;}
#menu li { float: none; margin:  10px 0 0 0; font-size: 18px;   display: flex;}
#menu a { float: left;  color:gray; text-decoration: none;}
#menu .active a { color:#333;  font-weight: bold;}
.section { text-align: center; font: 50px "Microsoft Yahei"; color: #fff;}
.fp-controlArrow { display: none;}
.hide {display: none;}
</style>

<template>
    <div>
        <div class="container-logo">
            <a href="/">
                <img class="logo-main" src="/images/logo.png" alt="Logo" />
                <img class="logo-light" src="/images/logo.png" alt="Logo" />
            </a>
        </div>
        <div class="container-menu row align-items-center justify-content-between">
            <!-- Hamburger Menu Start -->
            <div class="col-auto">
            
                <div class="header-action-area">
                <button class="btn-menu">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <!-- <span class="menu-text">Menu</span> -->
                </div>
            </div>
            <!-- Hamburger Menu Start -->
        </div>
       
          <div  id="dowebok">
            <full-page :options="options" ref="fullpage">
                <div class="section">
                    <div class="pagebox1">
                        <div v-if="!isMobile">
                            <div v-for="(item,i) in bannerlist0" class="slide pic_pc" :key="i" :style="item.url">
                                <div class="slideimgbox"></div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-for="(item,i) in bannerlist1" class="slide pic_phone" :key="i" :style="item.url">
                                <!-- <img id="exp-0-1" class="hidden" src="/images/DSC_2353.png" alt="">
                                <img id="exp-0-2" class="hidden" src="/images/DSC_2352.png" alt=""> -->
                                <div class="slideimgbox"></div>
                            </div>
                            <div class="arrawbox">
                                <img src="/images/arraw02.gif" alt="">
                            </div>
                        </div>
                        
<!-- 
                        <div class="slide" :style="pic1">
                            <div class="slideimgbox"></div>
                        </div>
                        <div class="slide" :style="pic2">
                            <div class="slideimgbox"></div>
                        </div>
                        <div class="slide" :style="pic3">
                            <div class="slideimgbox"></div></div> -->
                        <div id="copyright" v-html="copyrightstr"></div>
                    </div>
                </div>
                <div class="section">
                    <div class="pagebox2 pageboxfullcontainer">
                        <div class="level3-title">
                            <h4>关于我们</h4>
                            <p>About Us</p>
                        </div>
                        <div class="level3-body bggraycolor pageboxcontainer">
                            <router-link :to="{path:'/info',query:{pid:itemDatapage2.parentId,fid:pidaboutus}}" class="blackcolor"><img id="exp-1-3" :src="imgbaseurl+itemDatapage2.headImgUrl" alt="" class="fleft hidden"/>
                            </router-link>
                            <div class="level3-textbox fleft" id="exp-1-box">
                                <p class="hidden level3-body-title" id="exp-1-1">{{itemDatapage2.title}}</p>
                                <p class="hidden level3-body-content" id="exp-1-2">
                                    {{itemDatapage2.description}}
                                </p>
                                <p class="level3-body-morelink"> <router-link :to="{path:'/info',query:{pid:itemDatapage2.parentId,fid:pidaboutus}}" class="blackcolor">MORE ></router-link> </p>
                            </div>
                        </div>

                        <div v-if="isMobile">
                            <div class="arrawbox">
                                <img src="/images/arraw02.gif" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="pagebox3 pageboxfullcontainer">
                        <div class="level3-title bottomline">
                            <h4>主营业务</h4>
                            <p>Main Business</p>
                        </div>
                        <div class="level3-p03">
                            <ul>
                                <li class="level3-p03-container fleft hidden"  v-for="(item,index) in tableDatapage3" :key="index" @click="gotobiz(item.id)" :id="'exp-2-'+index">
                                    <div :class="'level3-p03-imgbox icon'+(index+1)"></div>
                                    <div class="level3-p03-container_right">
                                    <p class="level3-p03-container-title bluecolor">{{item.title}}</p>
                                    <div class="level3-p03-container-contentbox">
                                        <p class="level3-p03-container-content">
                                            {{item.description}}
                                        </p>
                                    </div>
                                    
                                    </div>
                                </li>
                               
                            </ul>
                        </div>
                        <div v-if="isMobile">
                            <div class="arrawbox">
                                <img src="/images/arraw02.gif" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="pagebox6 pageboxfullcontainer">
                        <div class="pageboxfullcontainer">
                        <div class="level3-title">
                            <h4>QHSE管理</h4>
                            <p>administration</p>
                        </div>
                        <div class="level3-p06">
                            <router-link :to="{path:'/info',query:{pid:qesepid,fid:qesepid}}" class="blackcolor">
                            <div id="exp-3-1" class="qhse-img-box" :style="'background-image:url('+imgbaseurl+itemDatapage6.headImgUrl+')'"></div>
                            <p id="exp-3-2" class="hidden">{{itemDatapage6.description}}</p>
                            </router-link>
                        </div>
                        </div>
                        <div v-if="isMobile">
                            <div class="arrawbox">
                                <img src="/images/arraw02.gif" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="pagebox4 pageboxfullcontainer">
                        <div class="pb4-bg-left"></div>
                        <div class="pb4-bg-right"></div>
                        <div class="level4-title">
                            <h4>新闻中心</h4>
                            <p>News</p>
                        </div>
                        <div class="level3-p04 pageboxcontainer mt30">
                            <div class="level3-p04-left fleft">
                                <a href="javascript:void(0)" @click="gotodetail(tableDatapage4_1.id,tableDatapage4_1.parentId)">
                                <img :src="imgbaseurl+tableDatapage4_1.headImgUrl" :alt="tableDatapage4_1.title" class="fleft level3-p04-img"/>
                                </a>
                                <p class="level3-p04-container-title mt30">{{tableDatapage4_1.title}}</p>
                                <p class="level3-p04-container-content">
                                    {{tableDatapage4_1.description}}
                                </p>
                                <a href="javascript:void(0)" @click="gotodetail(tableDatapage4_1.id,tableDatapage4_1.parentId)" class="level3-p04-left-linkbtn">+</a>
                            </div>
                            <div class="level3-p04-right fleft" id="newsbox">
                                <ul class="level3-p04-cateline">
                                    <li><a :href="outsidelink">郝斯特新闻</a></li>
                                    <li @click="selectnum=3" :class="selectnum==3?'active':''">CNG上载业务</li>
                                    <li @click="selectnum=2" :class="selectnum==2?'active':''">物流运输</li>
                                    <li @click="selectnum=1" :class="selectnum==1?'active':''">贸易业务</li>
                                    <li @click="selectnum=0" :class="selectnum==0?'active':''">恒定动态</li>
                               
                                </ul>
                                <ul :class="selectnum==0?'level4-p04-news mt20':'hide'">
                                    <li v-for="(item,index) in tableDatapage4_2" :key="index">
                                        <a href="javascript:void(0)" @click="gotodetail(item.id,item.parentId)">
                                        <p class="level4-p04-newstitle">{{item.title}}</p>
                                        <p class="level4-p04-newsview">{{item.description}}</p>
                                        </a>
                                    </li>
                                </ul>
                                <ul :class="selectnum==1?'level4-p04-news mt20':'hide'">
                                    <li v-for="(item,index) in tableDatapage4_3" :key="index">
                                        <a href="javascript:void(0)" @click="gotodetail(item.id,item.parentId)">
                                        <p class="level4-p04-newstitle">{{item.title}}</p>
                                        <p class="level4-p04-newsview">{{item.description}}</p>
                                        </a>
                                    </li>
                                </ul>
                                <ul :class="selectnum==2?'level4-p04-news mt20':'hide'">
                                    <li v-for="(item,index) in tableDatapage4_4" :key="index">
                                        <a href="javascript:void(0)" @click="gotodetail(item.id,item.parentId)">
                                        <p class="level4-p04-newstitle">{{item.title}}</p>
                                        <p class="level4-p04-newsview">{{item.description}}</p>
                                        </a>
                                    </li>
                                </ul>
                                <ul :class="selectnum==3?'level4-p04-news mt20':'hide'">
                                    <li v-for="(item,index) in tableDatapage4_5" :key="index">
                                        <a href="javascript:void(0)" @click="gotodetail(item.id,item.parentId)">
                                        <p class="level4-p04-newstitle">{{item.title}}</p>
                                        <p class="level4-p04-newsview">{{item.description}}</p>
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </div>
                        <div v-if="isMobile">
                            <div class="arrawbox">
                                <img src="/images/arraw02.gif" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="pagebox5 pageboxfullcontainer">
                        <div class="level3-title bottomline">
                            <h4>联系我们</h4>
                            <p>Contact Us</p>
                        </div>
                        <div class="level3-p05-box">

                    
                            <div class="level3-p05">
                                <div class="level3-p05-content mt30">
                                    <router-link :to="{path:'/job/info',query:{fid:pidcontactus,pid:lianxiwm}}">
                                        {{itemDatapage5.description}}
                                    </router-link>
                                </div>
                                <div class="level3-p05-imgs mt20">
                                    <img v-for="(item,index) in tableDatapage5" class="hidden" :key="index" :src="imgbaseurl+item.imgUrl" :alt="item.title" :id="'exp-5-'+index">
                                </div>
                                <div class="level3-p05-imgs_light mt20">
                                    <img v-for="(item,index) in tableDatapage5_sort" :key="index"  
                                    :class="item.altWord" 
                                    :src="imgbaseurl+item.imgUrl" :alt="item.title">
                                </div>
                                <div class="level3-p05-bottom">
                                    <router-link :to="{path:'/job/find/list',query:{fid:pidcontactus,pid:pidemployment}}">社会招聘</router-link>
                                    <router-link :to="{path:'/job/find/list',query:{fid:pidcontactus,pid:pidshool}}">校园招聘</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </full-page>
            </div>

        <!--== Scroll Top Button ==-->
        <div class="scroll-to-top"><span class="icofont-rounded-up"></span></div>

        <!--== Start Side Menu ==-->
        <aside class="off-canvas-wrapper">
            <div class="off-canvas-inner">
            <div class="off-canvas-overlay"></div>
            <!-- Start Off Canvas Content Wrapper -->
            <div class="off-canvas-content">
                <!-- Off Canvas Header -->
                <div class="off-canvas-header">
                <div class="close-action">
                    <button class="btn-close"><i class="icon_close"></i></button>
                </div>
                </div>
    
                <div class="off-canvas-item">
                <!-- Start Asside Menu Wrapper -->
                <div class="asside-navigation-area">
                    <ul class="asside-menu nav" id="assideMenuNav">
                        <li><a href="javascript:void(0)" @click="link(0,'')">网站首页</a></li>
                        <li v-for="(item,index) in menutree" :class="item.childs.length>0 ? 'dropdown-submenu' : ''" :id="'submenu'+index"  :key="index">
                            <a class="collapsed" :href="item.childs.length>0 ? 'javascript:void(0)' : '/#/info?pid='+qesepid+'&fid='+qesepid" data-bs-toggle="collapse" :data-bs-target="'#collapse'+index"
                            :aria-controls="'collapse'+index"><span>{{item.title}}</span></a>
                            <ul class="dropdown-nav collapse" :id="'collapse'+index" :aria-labelledby="'submenu'+index"
                            data-bs-parent="#assideMenuNav">
                                <li v-for="(child,i) in item.childs" :key="i"><a href="javascript:void(0)" @click="link(index+1,child)">{{child.title}}</a></li>
                                <li v-if="item.id==news_mainid"><a :href="outsidelink" target="_blank">郝斯特新闻</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="https://www.host318.com/" target="_blank">
                                四川郝斯特
                            </a>
                            </li>
                    </ul>
                </div>
                <!-- End Asside Menu Wrapper -->
                </div>
                <div class="off-canvas-bottom">
                    <div class="qrcode-box">
                        <p>{{qrcodeitem.title}}</p>
                        <img :src="imgbaseurl+qrcodeitem.imgUrl" alt="" />
                    </div>
                </div>

                <!-- Off Canvas Footer -->
                <div class="off-canvas-footer"></div>
            </div>
            <!-- End Off Canvas Content Wrapper -->
            </div>
        </aside>
        <!--== End Side Menu ==-->
    </div>
  
</template>


<script>
import '@/assets/fullpage.min.css'
import configration from '@/tools/js/enumconfig'
import VueWindow from '@/tools/js/VueWindow'
export default {
    data(){
        return {
            options: {
                licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
                //是否显示导航，默认为false
                navigation: true,
                navigationPosition: 'left',
                //为每个section设置背景色
                sectionsColor: [ "#fff", "#fff", "#fff", "#fff", "#fff","#fff"],
                navigationTooltips: ["首页","关于我们","主营业务","QHSE管理","新闻资讯","联系我们"],
                anchors: ['page1', 'page2', 'page3', 'page6','page4','page5'],

                // sectionsColor: [ "#fff"],
                // navigationTooltips: ["首页"],
                // anchors: ['page1'],

                // 是否显示当前页面小圆点导航的提示信息，不需要鼠标移上
                showActiveTooltip: true,
                controlArrows: false,
                
                afterLoad: this.afterLoad,
                //onLeave: this.onLeave,
                // menu: '#menu',
                slidesNavigation:true,
                slidesNavPosition:'bottom',
                controlArrowColor: 'none',
            },
            imgbaseurl : this.$baseURL.fileurl,

            pidgroupnews:configration.config.enum.pidgroupnews,                 //新闻-集团新闻
            pidjianjie:configration.config.enum.pidjianjie,                     //关于我们-简介
            pidleadertrain:configration.config.enum.pidleadertrain,             //主营业务-干部培训

            pidcontactus:configration.config.enum.pidcontactus,                 //联系我们
            lianxiwm:configration.config.enum.pidemployeecare,                  //联系方式
            pidshool:configration.config.enum.pidshool,                         //校园招聘
            pidemployment:configration.config.enum.pidemployment,               //社会招聘

            pidhwse:configration.config.enum.pidbiz,                            //qhse pid

            pidaboutus:configration.config.enum.pidguanyuwomen,
            news_mainid:configration.config.enum.pid_news_main,                 //新闻中心主id

            outsidelink:configration.config.enum.news_outside_link,

            page1parameters:{
                parentId:configration.config.enum.homepage1
            },
            tableDatapage1:[],
            itemDatapage2:{},
            tableDatapage3:[],
            tableDatapage4_1:{},
            tableDatapage4_2_pid:configration.config.enum.pidgroupnews,
            tableDatapage4_2:[],
            tableDatapage4_3_pid:configration.config.enum.pidtradenews,
            tableDatapage4_3:[],
            tableDatapage4_4_pid:configration.config.enum.pidnotice,
            tableDatapage4_4:[],
            tableDatapage4_5_pid:configration.config.enum.cngupload,
            tableDatapage4_5:[],

            qesepid :configration.config.enum.homepage6,            ///QHSE管理分类id
  
            tableDatapage4:[],
            tableDatapage5:[],
            tableDatapage5_sort:[],
            itemDatapage5:{},
            itemDatapage6:{},
            homepage1:configration.config.enum.homepage1,
            menutree:[],

            bannerlist0:[{'url':'background-image:url(images/banner-01.jpg)','type':'pc'},{'url':'background-image:url(images/banner-02.jpg)','type':'pc'}],
            bannerlist1:[{'url':'background-image:url(images/banner-01.jpg)','type':'pc'}],
          
            cur:['','','','','',''],
            selectnum:0,

            copyrightstr:'',
            qrcodeitem:{}
        }
    },
    methods:{
        afterLoad (anchorLink, item) {
            switch(item.index){
                case 0:
                    
                    // $("#exp-0-1").addClass('show animate__animated animate__fadeInDown');
                    // $("#exp-0-2").addClass('show animate__animated animate__fadeInUp');
                    break;
                case 1:
                    $("#exp-1-box").show();
                    $("#exp-1-1").addClass('show animate__animated animate__fadeInDown');
                    $("#exp-1-2").addClass('show animate__animated animate__fadeInUp');
                    $("#exp-1-3").addClass('show animate__animated animate__zoomIn');
                    break;
                case 2:
                    $("#exp-2-0").addClass('show animate__animated animate__zoomIn');
                    $("#exp-2-1").addClass('show animate__animated animate__zoomIn');
                    $("#exp-2-2").addClass('show animate__animated animate__zoomIn');
                    $("#exp-2-3").addClass('show animate__animated animate__zoomIn');
                    $("#exp-2-4").addClass('show animate__animated animate__zoomIn');
                    $("#exp-2-5").addClass('show animate__animated animate__zoomIn');
                    break;
                case 3:
                    //$("#exp-3-1").addClass('show animate__animated animate__zoomIn');
                    $("#exp-3-2").addClass('show animate__animated animate__fadeInUp');
                    break;
                case 5:
                    $("#exp-5-0").addClass('show animate__animated animate__fadeInUp');
                    $("#exp-5-1").addClass('show animate__animated animate__fadeInDown');
                    $("#exp-5-2").addClass('show animate__animated animate__fadeInUp');
                    break;
            }
        },
        getmenus:function(){
            let vm = this;
            let tpstr = localStorage.getItem(configration.config.enum.cache_menu);
            if(tpstr !=undefined && tpstr.length>0){
                vm.menutree = JSON.parse(tpstr);
                vm.countmenutree();
            }
            else{
                vm.$httpi.get('/api/v1/dictionary/DictionaryEntry/GetTreeByParentId?parentid='+configration.config.enum.mainid)
                .then(function (response) {
                    if(response != null && response.data.success){
                        vm.menutree = response.data.data;
                        
                        vm.countmenutree();

                        localStorage.setItem(configration.config.enum.cache_menu, JSON.stringify(vm.menutree));
                    }
                });
            }
        },

        countmenutree(){
            let vm = this;
            for(let i=0;i<vm.menutree.length;i++ ){
                if(vm.menutree[i].id == vm.pidaboutus)
                {
                    let tempgroup = [];
                    vm.menutree[i].childs.forEach(element => {
                        if(element.code.indexOf(configration.config.enum.menucodestart)>=0){
                            tempgroup.push(element);
                        }
                    });
                    vm.menutree[i].childs = tempgroup;
                    break;
                }
            }
        },

        gotodetail(id,pid){
            const vm = this;
            vm.$router.push({path:'/news/detail',query:{id:id,pid:pid,fid:vm.news_mainid}});
        },

        gotobiz(pid){
            this.$router.push({path:'/party/list',query:{pid:pid,fid:configration.config.enum.pidbiz}});
        },

        //获取首页大图
        getListpage1:function(){
            let vm = this;
            vm.$httpi.post('/api/v1/articles/adv/GetAll', vm.page1parameters)
            .then(function (response) {
                if(response.data.success){
                    vm.tableDatapage1 = response.data.data;
                    if(vm.tableDatapage1 != null && vm.tableDatapage1.length>0){
                        vm.bannerlist1=[];
                        vm.bannerlist0=[];
                    }

                    vm.tableDatapage1.forEach(element => {
                        switch(element.altWord){
                            case 'pc':
                                vm.bannerlist0.push({'url':'background-image:url('+vm.imgbaseurl+element.imgUrl+')','type':element.altWord});
                                break;
                            case 'phone':
                                vm.bannerlist1.push({'url':'background-image:url('+vm.imgbaseurl+element.imgUrl+')','type':element.altWord});
                                break;
                        }
                        //vm.bannerlist.push({'url':'background-image:url('+vm.imgbaseurl+element.imgUrl+')','type':element.altWord});
                    });
 
                }
            });
            
        },

        //关于我们内容获取
        getData2:function(){
            let vm = this;
           
            vm.$httpi.get('/api/v1/articles/doc/getintro?pid='+configration.config.enum.pidjianjie)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemDatapage2 = response.data.data;
                }
            });
        },


        getListpage3:function(){
            let vm = this;
           
            vm.$httpi.post('/api/v1/dictionary/DictionaryEntry/GetAll',{DictionaryParentId:configration.config.enum.pidbiz})
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.tableDatapage3 = response.data.data;
                }
            });
        },

        getListpage4:function(){
            let vm = this;
            vm.$httpi.get('/api/v1/articles/doc/GetHomeList')
            .then(function (response) {
                if(response.data.success){
                    vm.tableDatapage4 = response.data.data;

                    for(var i = 0; i<vm.tableDatapage4.length;i++){
                        if(vm.tableDatapage4[i].onTop){
                            vm.tableDatapage4_1 = vm.tableDatapage4[i];
                           // break;
                        }
                        if(vm.tableDatapage4[i].parentId == vm.tableDatapage4_2_pid && !vm.tableDatapage4[i].onTop){
                            vm.tableDatapage4_2.push(vm.tableDatapage4[i]);
                            //break;
                        }
                        if(vm.tableDatapage4[i].parentId == vm.tableDatapage4_3_pid && !vm.tableDatapage4[i].onTop){
                            vm.tableDatapage4_3.push(vm.tableDatapage4[i]);
                           // break;
                        }
                        if(vm.tableDatapage4[i].parentId == vm.tableDatapage4_4_pid && !vm.tableDatapage4[i].onTop){
                            vm.tableDatapage4_4.push(vm.tableDatapage4[i]);
                           /// break;
                        }
                        if(vm.tableDatapage4[i].parentId == vm.tableDatapage4_5_pid && !vm.tableDatapage4[i].onTop){
                            vm.tableDatapage4_5.push(vm.tableDatapage4[i]);
                           /// break;
                        }
                    }
                }
            });
            
        },

        getData5:function(){
            let vm = this;
           
            vm.$httpi.get('/api/v1/articles/doc/getintro?pid='+configration.config.enum.pidlianxi)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemDatapage5 = response.data.data;
                }
            });
        },

        getListpage5:function(){
            let vm = this;
            vm.$httpi.post('/api/v1/articles/adv/GetAll', {
                parentId:configration.config.enum.homepage5
            })
            .then(function (response) {
                if(response.data.success){
                    vm.tableDatapage5 = response.data.data;
                    vm.tableDatapage5_sort = vm.tableDatapage5.map(obj => ({ ...obj }));
                    vm.tableDatapage5_sort.sort((a,b) => {
                        if(a.altWord > b.altWord) return -1;
                        if(a.altWord > b.altWord) return 1;
                        return 0;
                    });
                    
                }
            });
            
        },
        getListpage6:function(){
            let vm = this;
            vm.$httpi.get('api/v1/articles/doc/getintro?pid='+configration.config.enum.homepage6)
            .then(function (response) {
                if(response.data.success){
                    vm.itemDatapage6 = response.data.data;
                }
            });
        },

        //获取备案信息
        getwebinfo:function(){
            let vm = this;
            vm.copyrightstr = localStorage.getItem(configration.config.enum.cache_copyright);
            if(vm.copyrightstr==undefined || vm.copyrightstr.length<=0){
                vm.$httpi.get('api/v1/system/config/getitem?id='+configration.config.enum.sys_copyrightid)
                .then(function (response) {
                    if(response.data.success){
                        vm.copyrightstr = response.data.data.description;
                        localStorage.setItem(configration.config.enum.cache_copyright, JSON.stringify(vm.copyrightstr));
                    }
                });
            }else{ vm.copyrightstr = JSON.parse(vm.copyrightstr); }
        },
        //获取二维码
        getqrcodeinfo:function(){
            let vm = this;
            let tempstr = localStorage.getItem(configration.config.enum.cache_qrcode);
            if(vm.tempstr==undefined || vm.tempstr.length<=0){
                vm.$httpi.get('api/v1/articles/adv/GetList?num=1&pid='+configration.config.enum.adv_qrcodepid)
                .then(function (response) {
                    if(response.data.success){
                        vm.qrcodeitem = response.data.data[0];
                        localStorage.setItem(configration.config.enum.cache_qrcode, JSON.stringify(vm.qrcodeitem));
                    }
                });
            }else{ vm.qrcodeitem = JSON.stringify(tempstr); }
        },

        link(tp,item){
            const vm = this;
            let url = '/info';
            switch(tp){
                case 0:
                    vm.cur = ['','','','','','',''];
                    vm.$set(vm.cur,0, 'active')
                    vm.$router.push({path:'/'});
                    break;
                case 1:
                    vm.cur = ['','','','','','',''];
                    vm.$set(vm.cur,1, 'active')
                    
                    if(item.id == configration.config.enum.pidhonor)
                    {
                        url = '/pub/list';
                    }
                    vm.$router.push({path:url,query:{fid:item.parentId,pid:item.id}});
                    break;
                case 2:
                    vm.cur = ['','','','','','',''];
                    vm.$set(vm.cur,2, 'active')
                    vm.$router.push({path:'/party/list',query:{fid:item.parentId,pid:item.id}});
                    break;
                case 3:
                    vm.cur = ['','','','','','',''];
                    vm.$set(vm.cur,3, 'active')
                    vm.$router.push({path:'/info',query:{fid:item.id,pid:item.id}});
                    break;
                case 4:
                    vm.cur = ['','','','','','',''];
                    vm.$set(vm.cur,4, 'active')
                    vm.$router.push({path:'/news/list',query:{fid:item.parentId,pid:item.id}});
                    break;
                case 5:
                    vm.cur = ['','','','','','',''];
                    vm.$set(vm.cur,5, 'active')
                    switch(item.code){
                        case 'doc-joinus-social':
                        case 'doc-joinus-shool':
                            vm.$router.push({path:'/job/find/list',query:{pid:item.id,fid:item.parentId}});
                            break;
                        default:
                            vm.$router.push({path:'/job/info',query:{pid:item.id,fid:item.parentId}});
                            break;
                    }
                    break;
            }
            $(".off-canvas-wrapper").removeClass('active');
            $(this).removeClass('fix');
        },

        initpage:function(){
            let vm = this;
            //绑定
            const hash = vm.$route.path.substr(5); // 获取URL的锚点参数
            // console.log('hash');
            // console.log(vm.$route);
            // console.log(hash);
            if(hash.length == 1)
            {
                let num = parseInt(hash);
                switch(num){
                    case 1:
                        //vm.$refs.fullpage.api.moveTo(2);silentMoveTo
                        vm.$refs.fullpage.api.moveTo(1);
                        break;
                    case 2:
                        vm.$refs.fullpage.api.moveTo(2);
                        break;
                    case 3:
                        vm.$refs.fullpage.api.moveTo(3);
                        break;
                    case 4:
                        vm.$refs.fullpage.api.moveTo(5);
                        break;
                    case 5:
                        vm.$refs.fullpage.api.moveTo(6);
                        break;
                    case 6:
                        vm.$refs.fullpage.api.moveTo(4);
                        break;
                }
                
            }
        }
    },
    mounted() {
        let vm = this;
        vm.getListpage1();
        vm.getData2();
        vm.getListpage3();
        vm.getListpage4();
        vm.getListpage5();
        vm.getData5();
        vm.getListpage6();
        vm.getmenus();
        vm.getwebinfo();
        vm.getqrcodeinfo();
        vm.initpage();

        
        // Off Canvas JS
        var canvasWrapper = $(".off-canvas-wrapper");
        $(".btn-menu").on('click', function() {
            canvasWrapper.addClass('active');
            $("body").addClass('fix');
        });

        $(".close-action > .btn-close, .off-canvas-overlay").on('click', function() {
            canvasWrapper.removeClass('active');
            $(this).removeClass('fix');
        });
      
        // Scroll Top Hide Show
        $(window).on('scroll', function(){
            if ($(this).scrollTop() > 250) {
            $('.scroll-to-top').fadeIn();
            } else {
            $('.scroll-to-top').fadeOut();
            }

            // Sticky Header
            if($('.sticky-header').length){
            var windowpos = $(this).scrollTop();
            if (windowpos >= 80) {
                $('.sticky-header').addClass('sticky');
            } else {
                $('.sticky-header').removeClass('sticky');
            }
            }

        });

        //Scroll To Top
        $('.scroll-to-top').on('click', function(){
            $('html, body').animate({scrollTop : 0},800);
            return false;
        });

    },
    computed: {
    isMobile() {
        return VueWindow.isMobile;
    }
}
}
</script>

